import { ReactElement } from 'react';

import { useTheme, IconButton as MUIIconButton, CircularProgress as Spinner } from '@mui/material';

import { merge } from 'lodash';

import useStyles from './styles';
import { IconButtonProps } from './types';

export default function IconButton(props: IconButtonProps): ReactElement {
  const theme = useTheme();

  const {
    children,
    color = 'secondary',
    disabled = false,
    loading = false,
    size = 'medium',
    variant = 'contained',
    sx,
    ...rest
  } = props;

  const style = useStyles({ theme });

  return (
    <MUIIconButton
      color={color}
      disabled={loading || disabled}
      disableFocusRipple
      disableRipple
      edge={false}
      {...rest}
      sx={merge(
        style[variant],
        disabled ? style.disabled[variant] : {},
        loading ? style.loading[variant] : {},
        sx
      )}>
      {loading ? (
        <Spinner
          size={size === 'small' ? theme.typography.h6.fontSize : theme.typography.h5.fontSize}
          thickness={4}
        />
      ) : (
        children
      )}
    </MUIIconButton>
  );
}
